<template>
  <Form
    ref="invoiceDetail"
    label-position="right"
    :label-width="120"
    :model="invoiceDetail"
  >
  <FormItem label="发票抬头"
    label-for="title"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.title || ''}}</span>
  </FormItem>
  <FormItem label="纳税人识别号"
    label-for="taxpayer_number"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.taxpayer_number || ''}}</span>
  </FormItem>
  <FormItem label="开户行"
    label-for="bank_name"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.bank_name || ''}}</span>
  </FormItem>
  <FormItem label="对公账号"
    label-for="bank_account"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.bank_account || ''}}</span>
  </FormItem>
  <FormItem label="注册地址"
    label-for="register_addr"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.register_addr || ''}}</span>
  </FormItem>
  <FormItem label="公司电话"
    label-for="company_phone"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.company_phone || ''}}</span>
  </FormItem>
  <FormItem label="收件人"
    label-for="recipients_name"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.recipients_name || ''}}</span>
  </FormItem>
  <FormItem label="手机号"
    label-for="recipients_phone"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.recipients_phone || ''}}</span>
  </FormItem>
  <FormItem label="邮政编码"
    label-for="recipients_postcode"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.recipients_postcode || ''}}</span>
  </FormItem>
  <FormItem label="收件地址"
    label-for="recipients_addr"
    style="margin-bottom:0"
  >
    <span>{{invoiceDetail.recipients_addr || ''}}</span>
  </FormItem>
</Form>
</template>

<script>
export default {
  props: {
    invoiceDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // invoiceDetail: {
      //   title: '',
      //   taxpayer_number: '',
      //   bank_name: '',
      //   bank_account: '',
      //   register_addr: '',
      //   company_phone: '',
      //   recipients_name: '',
      //   recipients_phone: '',
      //   recipients_postcode: '',
      //   recipients_addr: ''
      // }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/agInvoiceTemplate/InvoiceTempleRight.vue